import { useCallback, useState } from 'react'
import OutsideClickHandler from 'react-outside-click-handler'
import { mdiChevronDown } from '@mdi/js'

import { useAppSelector } from 'app/hooks'
import { UserImgContainer } from 'components/UserItems'
import { currentUserSelector } from 'features/auth/login/selectors'
import AccountMenuNav from './AccountMenuNav/AccountMenuNav'

import {
  StyledAccountMenuWrapper,
  StyledAccountMenuBtn,
  StyledArrowIcon,
  StyledDomainName,
} from './styles'
import {
  currentRootDomainIdSelector,
  rootDomainByIdSelector,
} from 'features/rootDomains/selectors'

function AccountMenu() {
  const currentUser = useAppSelector(currentUserSelector)
  const currentRootId = useAppSelector(currentRootDomainIdSelector)
  const currentRootDomain = useAppSelector(
    rootDomainByIdSelector(currentRootId)
  )

  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const handleMenuToggle = useCallback(
    () => setIsMenuOpen(!isMenuOpen),
    [isMenuOpen]
  )
  const handleMenuClose = useCallback(() => setIsMenuOpen(false), [])

  return (
    <StyledAccountMenuWrapper>
      <OutsideClickHandler onOutsideClick={handleMenuClose}>
        <StyledAccountMenuBtn
          type="button"
          onClick={handleMenuToggle}
          isMenuOpen={isMenuOpen}
        >
          <UserImgContainer
            size={24}
            profilePicUrl={currentUser.profilePicUrl}
          />
          <StyledDomainName>{currentRootDomain?.name}</StyledDomainName>
          <StyledArrowIcon
            path={mdiChevronDown}
            size={1}
            rotate={isMenuOpen ? 180 : 0}
          />
        </StyledAccountMenuBtn>
        {isMenuOpen && <AccountMenuNav onLinkClick={handleMenuClose} />}
      </OutsideClickHandler>
    </StyledAccountMenuWrapper>
  )
}

export default AccountMenu
